import { utils } from '@hh/global.js'

const { isDesktop } = utils

class ShopTheLook extends HTMLElement {
  constructor() {
    super()
    this.handleTriggerClick = this.handleTriggerClick.bind(this)
  }

  connectedCallback() {
    this.trigger = this.querySelector('button.stl-trigger-btn')
    this.trigger?.addEventListener('click', this.handleTriggerClick)
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleTriggerClick)
  }

  handleTriggerClick(e) {
    if (isDesktop()) return

    e.preventDefault()
    this.dataset.expanded = this.dataset.expanded === 'true' ? 'false' : 'true'
  }
}

customElements.define('shop-the-look', ShopTheLook)
